import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitEnquiry = (data) => api.post("/enquiries", data).then((r) => r.data);
export const submitApplication = (data) => api.post("/network-applications", data).then((r) => r.data);
export const submitSolarEstimate = (data) => api.post("/solar-estimates", data).then((r) => r.data);
export const fetchSolarInsights = (lat, lng) => api.get("/solar/insights", { params: { lat, lng } }).then((r) => r.data);
export const placesAutocomplete = (q) => api.get("/places/autocomplete", { params: { q } }).then((r) => r.data);
export const geocode = (params) => api.get("/geocode", { params }).then((r) => r.data);

export const adminFetch = (path, token) =>
  api.get(path, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const verifyAdmin = (token) =>
  api.post("/admin/verify", {}, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
